import { ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-score-radar-card',
    templateUrl: './score-radar-card.component.html',
    styleUrls: ['./score-radar-card.component.scss'],
    standalone: false
})
export class ScoreRadarCardComponent implements OnChanges {
   @Input() musaffaData: any;
   @Input() communityData: any;

   radarChartLabels: string[] = [
      'Community Impact & Social Controversies',
      'Labor Practices & Human Rights',
      'Product & Sector Involvement',
      'Environmental Responsibility',
      'Ethical Governance',
   ];

   radarChartData1: any[] = [];
   radarChartData2: any[] = [];


   radarChartOptions: any = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
         legend: { display: false },
         tooltip: {
            callbacks: {
               label: (context: any) => {
                  // For the outer dots dataset (index 1), return the corresponding label
                  if (context.datasetIndex === 1) {
                     return this.radarLegend[context.dataIndex].label;
                  }
                  // For the main dataset (index 0), show the value
                  return `${context.dataset.label}: ${context.raw}`;
               },
            },
         },
      },
      layout: { padding: 10 },
      scales: {
         r: {
            pointLabels: { display: false },
            ticks: {
               display: false,
            },
            min: 0,
            max: 100,
         },
      },
   };
   constructor(private changeDetectorRef: ChangeDetectorRef) { }

   radarLegend = [
      { label: 'Community Impact & Social Controversies', color: '#FF9A3B' },
      { label: 'Labor Practices & Human Rights', color: '#715CFF' },
      { label: 'Product & Sector Involvement', color: '#3E96FF' },
      { label: 'Environmental Responsibility', color: '#CF3EFF' },
      { label: 'Ethical Governance', color: '#16C976' },
   ];

   getScoreClass(score?: string | null): string {
      if (!score) return '';
      switch (score) {
         case 'Poor':
            return 'score-poor';
         case 'Weak':
            return 'score-weak';
         case 'Fair':
            return 'score-fair';
         case 'Good':
            return 'score-good';
         case 'Excellent':
            return 'score-excellent';
         default:
            return '';
      }
   }


   ngOnChanges(changes: SimpleChanges): void {
      // console.log('ngOnChanges triggered');
      // console.log('Changes:', changes);

      // Log raw input data with more details
      // console.log('musaffaData:', JSON.stringify(this.musaffaData));
      // console.log('communityData:', JSON.stringify(this.communityData));

      // Check if data exists (including nested properties)
      const hasMusaffaData = this.musaffaData &&
         this.musaffaData.community_impact_and_reputation !== undefined;

      const hasCommunityData = this.communityData &&
         this.communityData.community_impact_and_reputation !== undefined;

      // console.log(`Data check - musaffa: ${hasMusaffaData}, community: ${hasCommunityData}`);

      if (hasMusaffaData) {
         this.processChartData('musaffa', this.musaffaData, 1);
      } else {
         console.warn('musaffaData is missing or incomplete!');
         this.radarChartData1 = this.getEmptyChartData();
      }

      if (hasCommunityData) {
         this.processChartData('community', this.communityData, 2);
      } else {
         console.warn('communityData is missing or incomplete!');
         this.radarChartData2 = this.getEmptyChartData();
      }

      // Force chart update
      this.changeDetectorRef.detectChanges();
   }

   private processChartData(type: string, data: any, chartNumber: number): void {
      const requiredFields = [
         'community_impact_and_reputation',
         'human_rights_and_labor_practices',
         'product_and_sector_involvement',
         'environmental_responsibility',
         'ethical_governance'
      ];

      const scores = requiredFields.map(field => data[field] * 20);
      // console.log(`Computed ${type}Scores:`, scores);

      const chartData = [
         {
            data: scores,
            label: 'Score',
            backgroundColor: 'rgba(232, 89, 30, 0.25)',
            borderColor: 'rgba(232, 89, 30, 1)',
            pointRadius: 0,
            pointHoverRadius: 0,
            borderWidth: 1,
         },
         {
            data: [100, 100, 100, 100, 100],
            label: 'Outer Dots',
            backgroundColor: 'transparent',
            borderColor: 'transparent',
            pointRadius: 6,
            pointBorderWidth: 1,
            pointBackgroundColor: [
               '#FF9A3B',
               '#715CFF',
               '#3E96FF',
               '#CF3EFF',
               '#16C976',
            ],
            pointHoverRadius: 8,
            pointHoverBorderWidth: 2,
         }
      ];

      if (chartNumber === 1) {
         this.radarChartData1 = chartData;
      } else {
         this.radarChartData2 = chartData;
      }

      // console.log(`radarChartData${chartNumber}:`, chartData);
   }

   private getEmptyChartData(): any[] {
      return [
         {
            data: [0, 0, 0, 0, 0],
            label: 'Score',
            backgroundColor: 'rgba(232, 89, 30, 0.25)',
            borderColor: 'rgba(232, 89, 30, 1)',
            pointRadius: 0,
            pointHoverRadius: 0,
            borderWidth: 1,
         },
         {
            data: [100, 100, 100, 100, 100],
            label: 'Outer Dots',
            backgroundColor: 'transparent',
            borderColor: 'transparent',
            pointRadius: 6,
            pointBorderWidth: 1,
            pointBackgroundColor: [
               '#FF9A3B',
               '#715CFF',
               '#3E96FF',
               '#CF3EFF',
               '#16C976',
            ],
            pointHoverRadius: 8,
            pointHoverBorderWidth: 2,
         }
      ];
   }

}
